<template>
  <!-- <Layout> -->
  <div class="lost">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="error-template">
            <h1> Oops!</h1>
            <h1 class="mt-4 title">
              404
              <template v-if="resource">
                {{ resource }}
              </template>
              Not Found
            </h1>
            <div class="error-details">
              Sorry, an error has occured, Requested page not found!
            </div>
            <div class="error-actions rotated">
              <button class="btn btn-primary btn-lg" @click="navigation"
                ><span class="fa fa-home" aria-hidden="true"></span> Click Here
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- </Layout> -->
</template>
<script>
/* import Layout from '@layouts/main' */

export default {
  page: {
    title: '404',
    meta: [{ name: 'description', content: '404' }],
  },
  /* components: { Layout }, */
  props: {
    resource: {
      type: String,
      default: '',
    },
  },
  methods: {
    navigation() {
      this.$router.push({ name: 'authentication' })
    },
  },
}
</script>
<style scoped>
/* .lost {
  background-image: url('/images/lost.jpg');
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  height: 100vh;
} */
.title {
  text-align: center;
}
.error-template {
  padding: 40px 15px;
  text-align: center;
}
.error-actions {
  margin-top: 15px;
  margin-bottom: 15px;
}
.error-actions .btn {
  margin-right: 10px;
  margin-top: 50px;
  border-radius: 12px;
  border: none;
  background-color: #dc3545;
}
</style>
